<template>
  <span
    :class="[
      'inline-flex items-center gap-1.5 rounded px-2 py-0.5',
      'text-base font-semibold',
      swatch.chip
    ]"
  >
    <span
      :class="['h-2 w-2 rounded-sm', swatch.dot]"
      data-cy="cf-status-dot"
      aria-hidden="true"
    />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ token: string; label: string }>();

const SWATCHES: Record<string, { chip: string; dot: string }> = {
  red: { chip: "bg-red-50 text-red-700", dot: "bg-red-500" },
  yellow: { chip: "bg-amber-50 text-amber-800", dot: "bg-amber-500" },
  green: { chip: "bg-green-50 text-green-700", dot: "bg-green-600" }
};

// An unrecognised token renders neutrally rather than claiming a condition the
// server did not report — the same fallback CustomFormSubmissionStatusChip uses.
const swatch = computed(
  () =>
    SWATCHES[props.token] ?? {
      chip: "bg-gray-100 text-gray-700",
      dot: "bg-gray-400"
    }
);
</script>
